import { render, staticRenderFns } from "./Jugement.vue?vue&type=template&id=0f65287a&scoped=true&"
import script from "./Jugement.vue?vue&type=script&lang=js&"
export * from "./Jugement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f65287a",
  null
  
)

export default component.exports